import paths from "@/constants/paths";
import { userRoles } from "@/constants";

import AppManagementListPage from "@/containers/appManagement/ListPage";
import AppManagementSavePage from "@/containers/appManagement/SavePage";
import SuperAppListPage from "@/containers/superAppManagement/ListPage";
import SuperAppSavePage from "@/containers/superAppManagement/SavePage";
import ProfilePage from "@/containers/profile";
import Forbidden from "@/components/Forbidden";
import SMSListPage from "@/containers/transaction/SMSListPage";
import SMSConfigSavePage from "@/containers/setting/ConfigSavePage";

const routes = [
    {
        path: "/forbidden",
        isPublic: true,
        component: Forbidden,
    },
    {
        path: paths.appManagementList,
        component: AppManagementListPage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.appManagementCreate,
        component: AppManagementSavePage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.appManagementDetail,
        component: AppManagementSavePage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.superAppList,
        component: SuperAppListPage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.superAppCreate,
        component: SuperAppSavePage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.superAppDetail,
        component: SuperAppSavePage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.smsList,
        component: SMSListPage,
        roles: [userRoles.ADMIN, userRoles.ACCOUNTANT],
    },
    {
        path: paths.smsConfig,
        component: SMSConfigSavePage,
        roles: [userRoles.ADMIN],
    },
    {
        path: paths.profile,
        component: ProfilePage,
    },
];

export default routes;
